import React from 'react';
import cn from 'classnames';
import styles from './Typography.module.scss';
import { SpacingBox } from './Boxes';
import { existsAndNotEmptyString } from '../utils/strings';

export const Paragraph = (props) => (
  <p style={props.style} className={props.className}>
    {props.children}
  </p>
);

export const InvertedParagraph = (props) => (
  <p className={cn(styles.invertedParagraph, props.className)}>
    {props.children}
  </p>
);

export const InfoParagraph = (props) => (
  <p className={cn(styles.infoParagraph, props.className)}>{props.children}</p>
);

export const RedParagraph = (props) => (
  <p className={styles.redParagraph}>{props.children}</p>
);

export const GreenParagraph = (props) => (
  <p className={styles.greenParagraph}>{props.children}</p>
);

export const ParagraphSavingSpaceWhenEmpty = (props) => (
  <p className={cn(styles.saveSpaceForParagraph)}>{props.children}</p>
);

export const Bold = (props) => (
  <p style={props.style} className={cn(styles.bold, props.className)}>
    {props.children}
  </p>
);

export const BoldOrParagraph = (props) => {
  if (props.bold) return <Bold>{props.children}</Bold>;
  return <Paragraph>{props.children}</Paragraph>;
};

export const HugeTitle = (props) => (
  <h1 className={styles.hugeTitle}>{props.children}</h1>
);

export const H1 = (props) => (
  <h1 className={props.className}>{props.children}</h1>
);

export const H2 = (props) => (
  <h2 className={props.className}>{props.children}</h2>
);

export const InvertedH2 = (props) => (
  <h2 className={styles.invertedH2}>{props.children}</h2>
);

export const LightH2 = (props) => (
  <h2 className={styles.h2Lite}>{props.children}</h2>
);

export const H3 = (props) => (
  <h3 onClick={props.onClick} className={cn(styles.h3, props.className)}>
    {props.children}
  </h3>
);

export const LightH3 = (props) => (
  <h3 {...props} className={cn(styles.h3Lite, props.className)}>
    {props.children}
  </h3>
);

export const H4 = (props) => (
  <h4 style={props.style} className={cn(styles.h4, props.className)}>
    {props.children}
  </h4>
);

export const Caption = (props) => (
  <p className={cn(styles.caption, props.className)}>{props.children}</p>
);

export const BoldCaption = (props) => (
  <p className={cn(styles.caption, styles.bold, props.className)}>
    {props.children}
  </p>
);

export const InfoCaption = (props) => (
  <p className={cn(styles.infoCaption, props.className)}>{props.children}</p>
);

export const SmallerParagraph = (props) => (
  <p className={cn(styles.smallerParagraph, props.className)}>
    {props.children}
  </p>
);

export const InfoSmallerParagraph = (props) => (
  <p className={cn(styles.infoSmallParagraph, props.className)}>
    {props.children}
  </p>
);

export const BoldSmallerParagraph = (props) => (
  <p className={cn(styles.boldSmallParagraph, props.className)}>
    {props.children}
  </p>
);

export const CaptionSavingSpaceWhenEmpty = (props) => (
  <p className={cn(styles.caption, styles.saveSpaceForCaption)}>
    {props.children}
  </p>
);

export const OneLineText = ({ TextComponent, children, className }) => (
  <TextComponent className={cn(styles.oneLineText, className)}>
    {children}
  </TextComponent>
);

export const SaveSpaceForParagraph = (props) => (
  <SpacingBox
    className={
      existsAndNotEmptyString(props.value)
        ? styles.saveSpaceForParagraphWithValue
        : styles.saveSpaceForParagraphWithoutValue
    }
    paddingTop="sm">
    {props.children}
  </SpacingBox>
);
